<template>
  <section class="core-promise">
    <div class="container">
      <div class="header-group reveal">
        <h2 class="section-title">Two Ways Bizzento Helps You Every Day</h2>
        <div class="accent-line"></div>
      </div>

      <div class="two-column">
        <div class="feature-column operations reveal slide-left">
          <div class="column-header">
            <div class="icon-wrapper">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M4 14.75V3.5a.5.5 0 0 1 .5-.5h10.5a.5.5 0 0 1 .5.5v11.25M4 14.75a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 1 0-4.5 0Z"
                />
                <path d="M15 3v11.25a2.25 2.25 0 1 0 4.5 0V3" />
                <path d="M11 7h2" />
                <path d="M11 11h2" />
              </svg>
            </div>
            <h3>The Hands: <span>Operations</span></h3>
          </div>

          <p class="column-subtitle">
            Bizzento handles the repetitive "Busy Work" so you can reclaim your
            time.
          </p>

          <ul class="feature-list">
            <li>
              <span
                ><strong>Virtual Assistant:</strong> Integrates with your site
                to guide shoppers.</span
              >
            </li>
            <li>
              <span
                ><strong>24/7 Response:</strong> Answers inquiries, bookings,
                and FAQs instantly.</span
              >
            </li>
            <li>
              <span
                ><strong>End-to-End Flow:</strong> Automates workflows from lead
                to loyalty.</span
              >
            </li>
          </ul>
        </div>

        <div class="feature-column strategy reveal slide-right">
          <div class="column-header">
            <div class="icon-wrapper">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .52 8.105V19a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6"
                />
                <path d="M9 13a4.5 4.5 0 0 0 3-4" />
                <path d="M6.003 5.125A3 3 0 1 0 12.001 5" />
                <path d="M14.001 7a3 3 0 1 0 4.417 3.55 4 4 0 0 1 .582 7.45" />
              </svg>
            </div>
            <h3>The Brain: <span>Strategy</span></h3>
          </div>

          <p class="column-subtitle">
            Bizzento analyzes the data to tell you exactly how to grow faster.
          </p>

          <ul class="feature-list">
            <li>
              <span
                ><strong>Performance Insights:</strong> Visualizes what products
                are winning.</span
              >
            </li>
            <li>
              <span
                ><strong>Growth Signals:</strong> Identifies untapped revenue
                opportunities.</span
              >
            </li>
            <li>
              <span
                ><strong>Strategic Advising:</strong> Real-time suggestions to
                optimize your day.</span
              >
            </li>
          </ul>
        </div>
      </div>

      <div class="footer-quote reveal delay-3">
        <div class="quote-box">
          <p class="tagline">"You decide. Bizzento executes and advises."</p>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.core-promise {
  --bg-warm-base: #f2eee0;
  --sunlight-glow: #faefca;
  --soft-gold: #f5e5b0;
  --dark-accent: #1a1a1a;
  --text-muted: #8e8a82;
  --gold-highlight: #d4af37;
  padding: 100px 24px;
  background-color: var(--bg-warm-base);
}

.container {
  max-width: 1100px;
  margin: 0 auto;
}

.column-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.icon-wrapper {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  background: var(--sunlight-glow);
  color: var(--gold-highlight);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
}

h3 {
  font-size: 1.5rem;
  margin: 0;
  line-height: 1.2;
}

h3 span {
  color: var(--gold-highlight);
}

.feature-column {
  background: white;
  padding: 40px;
  border-radius: 24px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
}

.feature-list {
  list-style: none !important;
  margin: 0;
  padding: 0;
}

.feature-list li {
  margin-bottom: 20px;
  padding-left: 24px;
  position: relative;
  line-height: 1.5;
  display: block;
}

.feature-list li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 1.1em;
  width: 8px;
  height: 8px;
  background-color: var(--soft-gold);
  border-radius: 50%;
}

.column-subtitle {
  color: var(--text-muted);
  font-size: 1.05rem;
  margin-bottom: 24px;
  line-height: 1.6;
}

.footer-quote {
  margin-top: 50px;
  margin-bottom: none;
  padding: 0 24px;
  text-align: center;
  width: 100%;
}

.quote-box {
  display: inline-block;

  padding: 24px 60px;
  border-radius: 100px;
  background: white;
  border: 1px solid var(--soft-gold);
  max-width: 90%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);
}

.tagline {
  font-size: clamp(1rem, 2vw, 1.25rem);
  font-style: italic;
  font-weight: 600;
  color: var(--dark-accent);
  margin: 0;
  line-height: 1.4;
}

@media (max-width: 768px) {
  .two-column {
    grid-template-columns: 1fr;
  }
  .column-header {
    gap: 12px;
  }
  h3 {
    font-size: 1.3rem;
  }
  .quote-box {
    padding: 20px 32px;
  }
}
</style>
